import { FC } from 'react';

import { CartEntryType, PreparedVariation, VariantMatrix } from '@telialt/models/src/EshopModel';
import { selectProductInCartCode } from '@telialt/utils/src/eshopSelectors';

import { useAddProductMutation } from '../../hooks/mutations/useAddProductMutation';
import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { mapToBadge } from './mapToBadge';
import { ProductVariationBadgesMemo } from './ProductVariationBadges';

type Props = {
    variantMatrix: VariantMatrix[];
};

export const ProductVariationBadgesConnected: FC<Props> = ({ variantMatrix }) => {
    const { cart } = useCartQuery();
    const { addProduct } = useAddProductMutation();

    /** @name productInCartCode
     *  ## Note: maybe also extracted from cart.entries[].product.categories[].name */
    const productInCartCode = selectProductInCartCode(cart);

    if (!variantMatrix || !productInCartCode) {
        return null;
    }

    const handleSelect = (variation: PreparedVariation) => {
        addProduct({
            code: variation.code,
            entryType: CartEntryType.PurchasableProduct,
        });
    };

    return (
        <ProductVariationBadgesMemo
            variantMatrix={variantMatrix}
            productInCartCode={productInCartCode}
            onSelect={handleSelect}
            mapToBadge={mapToBadge}
        />
    );
};
